import * as Actions from './_ActionTypes';
import * as Pre from './_PreActionNames';


export function GetAll(accessToken){
  return {
    type : Pre.CAMERA + Actions.ALL,
    accessToken,
    payload : {},
    socket : {
      send :true,
      keepSocket : true
    }
  }
}


export function Add(model , accessToken) {
    const act = {
        type: Pre.CAMERA + Actions.ADD,
        payload:  model,
        socket: { send: true , keepSocket : true},
        accessToken
    }
    return act;
}

export function Remove(cameraId , accessToken) {
    return {
        type: Pre.CAMERA + Actions.REMOVE,
        payload: { cameraId },
        socket: { send: true , keepSocket : true},
        accessToken
    }
}

export function Update(model , accessToken) {
    return {
        type: Pre.CAMERA + Actions.UPDATE,
        payload:  model , 
        socket: { send: true , keepSocket : true},
        accessToken
    }
}

